import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import { clearResponses } from '../../mazeActions';
import withAvatar from '../../../common/avatar/withAvatar';
import { stopAudio } from '../../../common/audio/audioActions';
import { unmountScreen, blockScreen, greyOutScreen } from '../../../common/screen/screenActions';
import { playPracticeScript, selectPracticeScreenResponse } from './MazePracticeActions';
import { PRACTICE } from '../../../constants/assessmentItemType';
import { goToModelScroll } from '../../../common/navigation/navigationActions';
import AvatarView from '../../../common/avatar/avatarView';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';
import MazePracticeView from './MazePracticeView';
import { setLanguageForMeasure } from '../../../common/utils/languageUtils';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    paragraphs: selectors.getMazeParagraphs(state, PRACTICE),
    questions: selectors.getMazeQuestionItems(state, PRACTICE),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    readPracticeScript: () => {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(playPracticeScript(ownProps.flowStrategy.instructions[PRACTICE]));
    },
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent());
        setLanguageForMeasure(dispatch, ownProps.flowStrategy);
    },
    onResponseSelected: (questionId, responseId) => {
        dispatch(
            selectPracticeScreenResponse(
                questionId,
                responseId,
                ownProps.flowStrategy.instructions[PRACTICE],
            ),
        );
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(clearResponses());
        dispatch(unmountScreen());
    },
    onNext: () => {
        dispatch(goToModelScroll(ownProps.flowStrategy.assessment));
    },
});

const avatarMapStateToProps = (_, ownProps) => {
    const { isExtendedView } = ownProps;
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        extendedViewPosition: AvatarView.Position.LOWER_FAR_LEFT,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig, isExtendedView);
    return {
        position,
        instructions: ownProps.flowStrategy.instructions.passageInstruction,
        animateAlex: true,
    };
};

const MazePracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MazePracticeView);

export default MazePracticeContainer;
